/** Les 12 statuts du workflow "Menus & Convives", partagés entre la modale de détail événement et la page
 *  dédiée (`EvenementielConvivesPage.tsx`) — un seul endroit à modifier si un libellé change, jamais deux
 *  copies qui pourraient diverger. Seuls les deux premiers sont posés par la Phase 2 ; les suivants seront
 *  posés par les phases qui les implémentent réellement (import, envoi, réponses, validation, jour J...). */
export const COLLECTE_STATUS_LABELS: Record<string, string> = {
    menus_a_configurer: 'Menu à configurer',
    menus_configures: 'Menu configuré',
    convives_importes: 'Convives importés',
    invitations_a_envoyer: 'Invitations à envoyer',
    invitations_envoyees: 'Invitations envoyées',
    reponses_en_cours: 'Réponses en cours',
    reponses_terminees: 'Réponses terminées',
    validation_en_attente: 'Validation en attente',
    validation_effectuee: 'Validation effectuée',
    production: 'Production',
    jour_j: 'Jour J',
    termine: 'Terminé',
};

export const COLLECTE_STATUS_ORDER = Object.keys(COLLECTE_STATUS_LABELS);
